import { render, staticRenderFns } from "./GeneralPrize.vue?vue&type=template&id=4717e868"
import script from "./GeneralPrize.vue?vue&type=script&lang=ts"
export * from "./GeneralPrize.vue?vue&type=script&lang=ts"
import style0 from "./GeneralPrize.vue?vue&type=style&index=0&id=4717e868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports